(() => {
  if (customElements.get('brvcity-why-tabs')) return;
  class WhyTabs extends HTMLElement {
    connectedCallback() {
      this._abort?.abort();
      this._abort = new AbortController();
      const signal = this._abort.signal;
      this.tabs = Array.from(this.querySelectorAll('[role="tab"]'));
      this.panels = Array.from(this.querySelectorAll('[role="tabpanel"]'));
      this.tabs.forEach((tab, index) => {
        tab.addEventListener('click', () => this.select(index), { signal });
        tab.addEventListener('keydown', (event) => {
          const keys = { ArrowDown: (index + 1) % this.tabs.length, ArrowUp: (index - 1 + this.tabs.length) % this.tabs.length, Home: 0, End: this.tabs.length - 1 };
          if (!(event.key in keys)) return;
          event.preventDefault();
          this.select(keys[event.key], true);
        }, { signal });
      });
      document.addEventListener('shopify:block:select', (event) => {
        const index = this.tabs.findIndex(tab => tab.dataset.blockId === event.detail?.blockId);
        if (index >= 0) this.select(index);
      }, { signal });
      this.select(0);
    }
    disconnectedCallback() { this._abort?.abort(); }
    select(index, focus = false) {
      if (!this.tabs[index]) return;
      const panelId = this.tabs[index].getAttribute('aria-controls');
      this.tabs.forEach((tab, i) => {
        tab.classList.toggle('is-active', i === index);
        tab.setAttribute('aria-selected', String(i === index));
        tab.tabIndex = i === index ? 0 : -1;
      });
      this.panels.forEach(panel => { panel.hidden = panel.id !== panelId; });
      if (focus) this.tabs[index].focus();
    }
  }
  customElements.define('brvcity-why-tabs', WhyTabs);
})();
